
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

import { getApiBaseUrl } from '@/utils/configService';

// Import our new components
import Logo from './navigation/Logo';
import NavItems from './navigation/NavItems';
import MobileNavItems from './navigation/MobileNavItems';
import UserActions from './navigation/UserActions';
import MobileMenuToggle from './navigation/MobileMenuToggle';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();
  const portalUrl = getApiBaseUrl();
  
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-1' : 'bg-white bg-opacity-95 py-4'
      }`}
    >
      <div className="container px-4 mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Logo scrolled={scrolled} />
          
          <nav className="hidden md:flex space-x-6 items-center overflow-x-auto">
            <NavItems scrolled={scrolled} />
          </nav>
        </div>
        
        <div className="flex items-center space-x-2">
          <UserActions 
            scrolled={scrolled}
          />

          <MobileMenuToggle 
            isOpen={isOpen} 
            toggleMenu={toggleMenu} 
          />
        </div>
      </div>
      
      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t">
          <nav className="container px-4 mx-auto py-4 flex flex-col">
            <MobileNavItems />
            <hr className="my-2" />
            <UserActions 
              scrolled={scrolled}
              isMobile={true}
            />
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
